import { DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MoedaService } from '../moeda-service/moeda.service';
import { Filtros } from './../../../..//shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../..//shared/crud/ListaBase';
import { RetornoSelecao } from './../../../..//shared/gridview/RetornoSelecao';
import { Parametro } from './../../../..//shared/service-base/parametro';

@Component({
  selector: 'app-moeda-lista',
  templateUrl: './moeda-lista.component.html',
  styleUrls: ['./moeda-lista.component.css']
})
export class MoedaListaComponent extends ListaBase implements OnInit {

  moedaDados: any;
  cols: any[];
  _selectedColumns: any[];
  parametrosFiltro: any;
  carregando: boolean;
  removeSelecionado = [];
  first = 0;
  rows = 10;

  dadosTranslate = {
    "Ano": "parametros.moeda.ano",
    "Mês": "parametros.moeda.mes",
    "Valor": "parametros.moeda.valor",
    "Remover": "parametros.moeda.remover"
  }

  constructor(service: MoedaService,
    toastr: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private number: DecimalPipe) { 
      super(service, toastr, router);
      this.route.queryParams.subscribe(params => {
        this.parametrosFiltro = params;
        this.carregarFiltrosParametros();
        this.router = router;
      });
    }

  ngOnInit(): void {
    this.buscar();
    this.cols = [
      { field: 'detalhe', header: ''},
      { field: 'mes', header: 'Mês' },
      { field: 'ano', header: 'Ano' },
      { field: 'valor', header: 'Valor'},
      { field: 'remover', header: 'Remover' }
    ];

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.id_dealer
      || this.filtros.id_categoria_compra
      || this.filtros.mes
      || this.filtros.ano;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.service.buscar(objFiltro)
      .then(res => {
        this.moedaDados = res.dados;
        this.formataValor();
        
        this.carregando = false;
      });
  }

  private formataValor() {
    this.moedaDados.forEach(element => {
      element.valor = this.formataNumero(element.valor);
    });
  }

  private formataNumero(valor) {
    return Intl.NumberFormat('pt-br').format(valor);
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.service ? this.first === (this.service.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.service ? this.first === 0 : true;
  }

  visualizar(registro) {
    const retorno: RetornoSelecao = new RetornoSelecao();
    retorno.novoCadastro = false;
    retorno.registro = registro;
    this.ver(retorno);
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }
    this.getTranslate('');
    this.cdRef.detectChanges();
  }

  marcarRemoverSelecionados(dados){
    if(this.removeSelecionado.indexOf(dados.id) == -1){
      this.removeSelecionado.push(dados.id);
    }else{
      this.removeSelecionado.splice(this.removeSelecionado.indexOf(dados.id),1);
    }
  }

  RemoverSelecionados(){
    for (let i = 0; i < this.removeSelecionado.length; i++) {
      this.service.excluir(this.removeSelecionado[i]);
    }
    const mensagem = 'Registro(s) selecionado(s) sendo Excluido(s)';
    this.toastr.success(mensagem, 'Excluido(s)');
    this.removeSelecionado = [];
    setTimeout(() =>{ 
      this.buscar();
     }, 3000);
    
  }

}
